import React from 'react';
import Portal from './../common/Portal';
import _ from 'lodash';
import PropTypes from 'prop-types';
import AuthenticationController from '../controllers/AuthenticationController';
import ThumbnailUtil from '../util/ThumbnailUtil';
import EditUserAccount from '../common/EditUserAccount';
import UserProfileImage from '../common/UserProfileImage';
import Popover from '../Popover';
import ViewUtil from '../ViewUtil';
import t from '../i18n/I18n';
import Authenticator2 from '../auth/Authenticator2';
import { togglePageLoadPlaceholder } from '../util/DOMUtil';

import './UserPopover.css';
import Switch from '../common/form/Switch';
import Theme from '../basic/Theme';
import { ThemeSetup } from '../themes/ThemeSetup';
import System from '../basic/System';
import SaveSettings from '../queries/settings/SaveSettings';
import { openURL } from '../util/ExtUtil';
import PreviewAuthController from '../controllers/preview/PreviewAuthController';
import ParamsUtil from '../util/ParamsUtil';
import { A } from '../common/elements';
import SessionUtil from '../util/session/SessionUtil';
import { canShowSettingsTab } from '../util/FeatureUtil';

const debug = require('../debug/debug')('wc:login:UserPopover');

export default class UserPopover extends React.Component {
  static propTypes = {
    userId: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      fullName: undefined,
      modal: '',
      showPopover: false,
      theme: System.getTheme()
    };
  }

  componentDidMount() {
    ThumbnailUtil.loadUserFullName(this.props.userId)
      .then((fullName) => {
        this.setState({ fullName });
      })
      .catch(_.noop);
  }

  onSettingClick = (e) => {
    e.preventDefault();
    this.setState({ showPopover: false });
    ViewUtil.switchToTab('SETTINGS');
  };

  show = () => {
    this.setState({ showPopover: true });
  };

  hide = () => {
    this.setState({ showPopover: false });
  };
  onThemeChange = () => {
    const { theme } = this.state;
    const toggled = theme === Theme.LIGHT ? Theme.DARK : Theme.LIGHT;
    Theme.setTheme(toggled);
    ThemeSetup.updateTheme();
    this.setState({ theme: toggled }, () => {
      window.render();
    });
    SaveSettings.save(SaveSettings.THEME, Theme.getTheme().getName());
  };

  render() {
    const isLinkUser = window.gs.isLinkUser;
    if (isLinkUser) {
      return null;
    }

    const { userId } = this.props;
    const { showPopover, fullName, modal, theme } = this.state;
    const rect = this._node ? this._node.getBoundingClientRect() : {};

    const props = {
      ref: (node) => (this._node = node),
      className: 'button',
      style: { backgroundImage: showPopover ? 'url(images/arrow_up.svg)' : 'url(images/arrow_down.svg)' },
      onClick: this.show
    };

    return (
      <div name="UserPopover">
        <div {...props}>
          <UserProfileImage size={40} userId={userId} />
        </div>
        {showPopover ? (
          <Portal closeOnOutsideClick closeOnEsc onClose={this.hide} defaultOpen={showPopover}>
            <Popover top={rect.bottom} right={window.innerWidth - rect.right} onClose={this.hide}>
              <div name="UserPopover_Portal">
                {fullName ? <div className="dark item">{fullName}</div> : null}
                <div style={{ borderTop: '1px solid var(--separator-color)' }} />
                {/* <div
                  onClick={() => {
                    this.setState({ modal: 'EDIT_USER_PROFILE', showPopover: false });
                  }}
                  className="clickable item">
                  {t('EDIT_USER_PROFILE')}
                </div> */}
                {
                  canShowSettingsTab() ?
                    <A
                      className="clickable item"
                      style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
                      href={ParamsUtil.appendStateParams({ activeTab: 'SETTINGS' })}
                      onClick={this.onSettingClick}>
                      Settings
                    </A> : null
                }
                <div onClick={() => this.logout()} className="clickable item">
                  {t('LOGOUT')}
                </div>
                <div className="clickable item">
                  <Switch checked={theme === Theme.DARK} label={t('DARK_MODE')} onChange={this.onThemeChange} />
                </div>
                {window.gs.version ? <div className="small item">v{window.gs.version}</div> : null}
              </div>
            </Popover>
          </Portal>
        ) : null}
        {modal === 'EDIT_USER_PROFILE' ? (
          <EditUserAccount onPasswordChange={() => this.logout()} onClose={() => this.setState({ modal: null })} />
        ) : null}
      </div>
    );
  }

  logout() {
    this.actionOnLogout();
    SessionUtil.logout();
  }

  openGlobalLogoutWindow(url: String) {
    debug('[openGlobalLogoutWindow()(url:%s)]', url);
    openURL(url, '_blank'); // more consistent with other apps, instead of: window.open(url, 'O-AUTH GLOBAL LOGOUT', 'height=600,width=800');
  }

  actionOnLogout() {
    togglePageLoadPlaceholder(false);
    this.setState({ showPopover: false });
  }
}
